var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPlusBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.83984 18.7715C9.83984 19.2624 10.2378 19.6604 10.7287 19.6604C11.2197 19.6604 11.6176 19.2624 11.6176 18.7715V11.3393H19.272C19.7629 11.3393 20.1609 10.9414 20.1609 10.4505C20.1609 9.95954 19.7629 9.56157 19.272 9.56157H11.6176V1.22825C11.6176 0.737325 11.2197 0.339355 10.7287 0.339355C10.2378 0.339355 9.83984 0.737325 9.83984 1.22824V9.56157H1.72873C1.23781 9.56157 0.839844 9.95954 0.839844 10.4505C0.839844 10.9414 1.23781 11.3393 1.72873 11.3393H9.83984V18.7715Z",
    fill: "#1E293B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlusBlack);
export default __webpack_public_path__ + "static/media/ic_plus_black.5a433dec1ea293b1070f2ca3955ee1d5.svg";
export { ForwardRef as ReactComponent };